import React from "react";

const CTA = ({ setActiveNav }) => {
  return (
    <div className="cta">
      <a
        href="/assets/nima-sharifinia.pdf"
        target="_blank"
        className="btn"
      >
        Download CV
      </a>
      <a
        href="#contact"
        className="btn btn-primary"
        onClick={() => setActiveNav("#contact")}
      >
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
